import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/employee/[id]/dearest/book/external-confirm/page";

export const Route = createFileRoute(
  "/employee/$id/dearest/book/external-confirm",
)({
  component: Page,
});
